import { makeGlobalApiRequest } from "../../lib/globalApi";
import { SuppressedEmail } from "./types";

/**
 * Staff-only client for the SES suppression list (issue #1382). Both routes live
 * in the global-api service (see `lib/globalApi`) and 403 for non-staff callers.
 */

/** List suppressed addresses, most recently suppressed first. */
export const listSuppressions = async (): Promise<SuppressedEmail[]> => {
  const rows = await makeGlobalApiRequest({
    path: "/api/v1/suppressions",
    method: "GET",
  });
  return (rows ?? []) as SuppressedEmail[];
};

/**
 * Un-suppress an address so alerting can email it again — used once the
 * underlying mailbox issue is resolved. Note this is not permanent: a fresh
 * bounce or complaint re-suppresses the address automatically.
 */
export const unsuppressEmail = async (email: string): Promise<void> => {
  await makeGlobalApiRequest({
    path: `/api/v1/suppressions/${encodeURIComponent(email)}`,
    method: "DELETE",
  });
};
